import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { AlertService } from 'src/app/_services/alert.service';
import { forkJoin } from 'rxjs';
import { ApiHttpService } from 'src/app/_services/api-http.service';

import { environment } from 'src/environments/environment';
import { PaymentGatewayService } from '../payment-gateway-service';
const {API_URLPG} = environment;
export interface Acquirer {
  id: string;
  name: string;
}

export interface Merchant {
  emailId: string;
  businessName: string;
  merchantEmailId: string;
}

@Component({
  selector: 'app-merchant-mapping',
  templateUrl: './merchant-mapping.component.html',
  styleUrls: ['./merchant-mapping.component.scss']
})
export class MerchantMappingComponent implements OnInit {
  
  private systemAdmin : any = environment.adminUser;
  merchantMappingForm: FormGroup;
  merchants: any = [];
  acquirerList: any = [];
  submitted: boolean = false;

  constructor(private _FB: FormBuilder, private _MBS: PaymentGatewayService, private alertService: AlertService, private apiHttpService: ApiHttpService) { }

  ngOnInit(): void {
    this.initForm();
    this.getAllMerchants();
    this.getAllAcquirerTypes();
  }

  initForm() {
    // let userType: string = localStorage.getItem('userType')!;
    // let email: string = localStorage.getItem('email')!;
    let userType: string = "Admin";
    let email: string = this.systemAdmin;
    this.merchantMappingForm = this._FB.group({
      merchantEmailId: ['', Validators.required],
      acquirer: ['', Validators.required],
      domestic: [false, Validators.required],
      international: [false, Validators.required],
      userType: [userType],
      loggedInUserEmailId: [email],
      emailId: [email],
      mapString: ['', Validators.required],
      accountCurrencySet: this._FB.array([], Validators.required)
    }, { validators: [this.atLeastOneCheckboxSelected, this.atLeastOneTreeSelected.bind(this)] })
  }

  atLeastOneCheckboxSelected(control: AbstractControl): ValidationErrors | null {
    const formGroup = control as FormGroup;
    const domestic = formGroup.get('domestic')?.value;
    const international = formGroup.get('international')?.value;

    // Return error if both checkboxes are false
    return (domestic === false && international === false)
      ? { atLeastOneSelected: 'At least one checkbox must be selected.' }
      : null;
  }

  atLeastOneTreeSelected(control: FormGroup): { [key: string]: boolean } | null {
    // Access mopList from global scope (not from FormGroup)
    const formGroup = control as FormGroup;
    const mapString = formGroup.get('mapString')?.value;

    // const isAnySelected = this.mopList.some((item: any) =>
    //   // Ensure the item itself or a subcategory under it is selected
    //   item.subCategories.some((sub: any) =>
    //     sub.selected || (sub.actions && sub.actions.some((action: any) => action.selected))
    //   )
    // );
    return mapString.length ? null : { atLeastOneTreeSelected: true };
  }

  get merchantMappingFormControls() {
    return this.merchantMappingForm.controls;
  }

  get accountCurrencySet(): FormArray {
    return this.merchantMappingForm.get('accountCurrencySet') as FormArray;
  }

  changeData() {
    if (this.merchantMappingForm.get('merchantEmailId')?.valid && this.merchantMappingForm.get('acquirer')?.valid) {
      this.getMopSetUpCurrency();
    }
  }

  changeCurrency(item: any) {
    item.selected ? this.addCurrencySet(item.code) : this.removeCurrencySet(item.code);
  }

  addCurrencySet(currencyCode: string): void {
    const setGroup = this._FB.group({
      currencyCode: [currencyCode, Validators.required],
      merchantId: ['', Validators.required],
      password: [''],
      txnKey: [''],
      adf1: [''],
      adf2: [''],
      adf3: [''],
      adf4: [''],
      adf5: ['', Validators.required],
      adf6: [''],
      adf7: [''],
      adf8: [''],
      adf9: [''],
      adf10: [''],
      adf11: [''],
    });
    this.accountCurrencySet.push(setGroup);
  }

  removeCurrencySet(code: any): void {
    const index = this.accountCurrencySet.value.findIndex((item: any) => item.currencyCode === code);
    this.accountCurrencySet.removeAt(index);
  }

  getSelectedPaths() {
    let selectedPaths: string[] = [];

    // Iterate through each category and its subcategories and actions
    this.mopList.forEach((category: any) => {
      if (category.selected) {
        category.subCategories.forEach((subCategory: any) => {
          if (subCategory.selected) {
            if (subCategory.actions) {
              subCategory.actions.forEach((action: any) => {
                if (action.selected) {
                  selectedPaths.push(`${category.name}-${subCategory.key}-${action.name}`);
                }
              });
            } else {
              selectedPaths.push(`${category.name}-${subCategory.key}`);
            }
          }
        });
      }
    });
    // Return the comma-separated list
    this.merchantMappingForm.get('mapString')?.setValue(selectedPaths.join(','));
  }

  getAllMerchants(): void {
    this._MBS.getAllMerchants().subscribe({
      next: (data: any) => {
        if (data && data.length) {
          this.merchants = data;
        } else {
          this.merchants = [];
        }
      },
      error: err => {
        this.alertService.toastErrorMessageAlert({
          title: err?.Message || 'Something went wrong!',
        });
      }
    });
  }

  getAllAcquirerTypes() {
    this._MBS.getAllAcquiers().subscribe({
      next: (data: any) => {
        if (data) {
          this.acquirerList = Object.keys(data).map((_: any) => {
            return { key: _, title: data[_] }
          });
        } else {
          this.acquirerList = [];
        }
      },
      error: err => {
        this.alertService.toastErrorMessageAlert({
          title: err?.Message || 'Something went wrong!',
        })
      }
    })
  }

  currencies: any = [];
  mopList: any = [];
  mopListold: any = [];
  getMopSetUpCurrency() {
    // let email: string = localStorage.getItem('email')!;
    let email: string = this.systemAdmin;
    const requestData = {
      merchantEmailId: this.merchantMappingForm.value.merchantEmailId,
      acquirer: this.merchantMappingForm.value.acquirer,
      loggedUserEmailId: email
    };
    forkJoin([
      this.apiHttpService.post(`${API_URLPG}crm-merchant-billing/mopSetupAction`, requestData),
      this.apiHttpService.post(`${API_URLPG}crm-merchant-billing/mopSetupDisplay`, requestData)
    ]).subscribe(([setData, displayData]) => {
      // let userType: string = localStorage.getItem('userType')!;
      let userType: string = "Admin";
      // let email: string = localStorage.getItem('email')!;
      let email: string = this.systemAdmin; 
      this.accountCurrencySet.clear();
      this.merchantMappingForm.reset({ acquirer: this.merchantMappingForm.value.acquirer, merchantEmailId: this.merchantMappingForm.value.merchantEmailId, mapString: '', domestic: false, international: false, userType, loggedInUserEmailId: email, emailId: email, accountCurrencySet: this._FB.array([], Validators.required) });
      if (setData && setData.status === "OK") {
        this.currencies = Object.keys(setData.payload.currencies).map((_: any) => ({ code: _, key: setData.payload.currencies[_], selected: false }));
        this.mopListold = setData.payload.mopList;
        this.mopList = Object.keys(setData.payload.mopListWithCodes).map((_: any) => {
          return {
            name: _,
            selected: false,
            subCategories: Object.keys(setData.payload.mopListWithCodes[_]).map((__: any) => ({
              name: setData.payload.mopListWithCodes[_][__],
              key: __,
              selected: false,
              ...(_ !== 'Net Banking' && {
                actions: [
                  { name: 'AUTHORISE', selected: false },
                  { name: 'SALE', selected: false },
                  { name: 'REFUND', selected: false }
                ]
              })
            }))
          }
        });
      } else {
        this.alertService.toastWarringMessageAlert({
          title: setData?.Message || setData?.message || 'Something went wrong!',
        })
      }
      if (displayData && displayData.status === "OK") {
        displayData.payload.acquirer = this.merchantMappingForm.value.acquirer;
        this.merchantMappingForm.patchValue(displayData.payload)
        this.merchantMappingForm.patchValue(displayData.payload.transactionRegion)
        this.merchantMappingForm.get('mapString')?.setValue(displayData.payload.mappedString.replace(/^,/, ''));
        displayData.payload.currencyString ? displayData.payload.currencyString.map((_: any) => {
          let indexVal = this.currencies.findIndex((__: any) => __.code === _.currencyCode);
          indexVal >= 0 ? this.currencies[indexVal].selected = true : null;
          const setGroup = this._FB.group({
            currencyCode: [_.currencyCode, Validators.required],
            merchantId: [_.merchantId, _.adf5 ? '' : Validators.required],
            password: [_.password],
            txnKey: [_.txnKey],
            adf1: [_.adf1],
            adf2: [_.adf2],
            adf3: [_.adf3],
            adf4: [_.adf4],
            adf5: [_.adf5, _.merchantId ? '' : Validators.required],
            adf6: [_.adf6],
            adf7: [_.adf7],
            adf8: [_.adf8],
            adf9: [_.adf9],
            adf10: [_.adf10],
            adf11: [_.adf11],
          });
          this.accountCurrencySet.push(setGroup);
        }) : null;

        displayData.payload.mappedString ? displayData.payload.mappedString.split(',').forEach((path: string) => {
          const [categoryName, subCategoryName, actionName] = path.split('-');
          const category = this.mopList.find((cat: any) => cat.name === categoryName);
          const subCategory = category?.subCategories.find((sub: any) => sub.key === subCategoryName);
          const action = subCategory?.actions?.find((act: any) => act.name === actionName);

          if (category) category.selected = true;
          if (subCategory) subCategory.selected = true;
          if (action) action.selected = true;
        }) : null;
      } else {
        this.alertService.toastWarringMessageAlert({
          title: displayData?.Message || displayData?.message || 'Something went wrong!',
        })
      }
    }, (error) => {
      this.alertService.toastErrorMessageAlert({
        title: error?.Message || 'Something went wrong!',
      })
    });

    // this._MBS.mopSetUpCurrency(requestData).subscribe({
    //   next: (data: any) => {
    //     if (data && data.status === "OK") {
    //       this.currencies = Object.keys(data.payload.currencies).map((_: any) => ({ code: _, key: data.payload.currencies[_], selected: false }));
    //       this.mopList = Object.keys(data.payload.mopList).map((_: any) => {
    //         return {
    //           name: _,
    //           selected: false,
    //           subCategories: data.payload.mopList[_].map((__: any) => ({
    //             name: __,
    //             selected: false,
    //             ...(_ !== 'Net Banking' && {
    //               actions: [
    //                 { name: 'AUTHORISE', selected: false },
    //                 { name: 'SALE', selected: false },
    //                 { name: 'REFUND', selected: false }
    //               ]
    //             })
    //           }))
    //         }
    //       });
    //     } else {
    //       this.alertService.toastWarringMessageAlert({
    //         title: data?.Message || data?.message || 'Something went wrong!',
    //       })
    //     }
    //   },
    //   error: err => {
    //     this.alertService.toastErrorMessageAlert({
    //       title: err?.Message || 'Something went wrong!',
    //     })
    //   }
    // })
  }

  // mopSetUpDisplay() {
  //   const requestData = {
  //     merchantEmailId: this.merchantMappingForm.value.merchantEmailId,
  //     acquirerCode: this.merchantMappingForm.value.acquirer
  //   };
  //   this._MBS.mopSetUpDisplay(requestData).subscribe({
  //     next: (data: any) => {
  //       if (data && data.status === "OK") {
  //       } else {
  //         this.alertService.toastWarringMessageAlert({
  //           title: data?.Message || data?.message || 'Something went wrong!',
  //         })
  //       }
  //     },
  //     error: err => {
  //       this.alertService.toastErrorMessageAlert({
  //         title: err?.Message || 'Something went wrong!',
  //       })
  //     }
  //   })
  // }

  changeMerchant(eve: any, controls: any, controlName: string, notNeedControl: string) {
    if (eve.target.value) {
      controls.get(controlName)?.clearValidators()
    } else {
      controls.get(controlName)?.addValidators([Validators.required])
    }
    controls.get(controlName)?.updateValueAndValidity()
  }

  saveMapping() {
    if (this.merchantMappingForm.valid && this.accountCurrencySet.length) {
      let obj = { ...this.merchantMappingForm.value, accountCurrencySet: JSON.stringify(this.merchantMappingForm.value.accountCurrencySet) };
      this._MBS.mopSetUp(obj).subscribe({
        next: (data: any) => {
          if (data && data.status === "OK") {
            this.alertService.toastSuccessMessageAlert({
              title: data?.message || 'Merchant mapping saved successfully!',
            })
          } else {
            this.alertService.toastWarringMessageAlert({
              title: data?.message || 'Something went wrong!',
            })
          }
        },
        error: err => {
          this.alertService.toastErrorMessageAlert({
            title: err?.Message || 'Something went wrong!',
          })
        }
      })
    } else {
      this.submitted = true;
    }
  }

}
